import React from 'react';

import PositionedGoodyHOC from '../PositionedGoodyHOC';
import { POSITIONED_GOODY_REFS } from '../../../../constants';

export default class Princess extends PositionedGoodyHOC {
	// 7
	render() {
		const style = {
			st2: {
				fill: '#FFFFFF',
			},
			st72: {
				fill: '#FFEAAE',
			},
		};
		return (
			<g>
				<circle ref={POSITIONED_GOODY_REFS.MARKER} cx="27.1190453" cy="29.5497303" />
				<path style={style.st72} d="M0.2587006,13.3136253c14.7030487,0,27.7795486-13.1139326,27.7795486-13.1139326h0.2204514
					c0,0,13.4825974,13.1972656,27.4825974,13.1972656l-1.8376045,10.1430674l-1.259449,0.3007812
					c-7.7548828,1.0131836-16.0501671,1.5200195-24.376339,1.5200195c-8.2880859,0-16.5295391-0.5014648-24.2502422-1.5053711
					L2.673183,23.537096L0.2587006,13.3136253z" />
				<path style={style.st2} d="M30.2737331,12.0654554l-0.0000038,0.0000048c-1.2203884,1.2203865-3.1990261,1.2203865-4.4194145,0
					l-0.0000038-0.0000048c-1.2203865-1.2203875-1.2203865-3.1990261,0-4.4194131l0.0000038-0.0000043
					c1.2203884-1.2203875,3.1990261-1.2203875,4.4194145,0l0.0000038,0.0000043
					C31.4941196,8.8664293,31.4941196,10.845068,30.2737331,12.0654554z" />
			</g>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Hat/Princess.js